import { CreditLineProvider, EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { PaymentTermType } from './payment-term-type.enum';
import { PaymentTermNetPayload, PaymentTermNetPayloadSchema } from './payment-term.net-payload';

export const PaymentTermSchema = z
    .object({
        type: EnumSchema(PaymentTermType),
        payload: PaymentTermNetPayloadSchema.optional(),
        provider: EnumSchema(CreditLineProvider).optional(),
    })
    .strict();

export class PaymentTerm extends FromSchema(PaymentTermSchema) {
    type: PaymentTermType;
    payload?: PaymentTermNetPayload;
    provider?: CreditLineProvider;
}
